import React from "react"
export function Baggage(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <g
        id="prefix__Artboard-Copy-19"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M23 13.998H1V7.286c0-.868.704-1.572 1.571-1.572h4.715V2.571C7.286 1.704 7.989 1 8.857 1h6.286c.868 0 1.571.704 1.571 1.571v3.143h4.715c.867 0 1.571.704 1.571 1.572v6.712zm0 2.007v5.424c0 .867-.704 1.571-1.571 1.571H2.57A1.571 1.571 0 011 21.429v-5.424h22zM9.643 5.715h4.714V3.356H9.643v2.357z"
          id="prefix__Bag"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
